module.exports = __webpack_public_path__ + "static/media/seed8.72dfb033.svg";